export const UPDATE_STATUS = 'updateStatus';
export const GET_FINAL_STATUS = 'getFinalStatus';
export const SHOW_NOTIFICATION = 'showNotification';
export const CHANGE_IS_DISABLED = 'changeIsDisabled';
export const APPEND_EXTERNAL_HTML = 'appendExternalHtml';
export const REMOVE_EXTERNAL_HTML = 'removeExternalHtml';
export const CHANGE_IS_SHOW_LOADER = 'changeIsShowLoader';
